import { FlexXY } from "../components/common/flexBox";
import TabComponent from "../components/home/tabComponent";
import styled from "styled-components";
import { Cookies } from "react-cookie";
import EnterpriseTabComponent from "../components/enterprise/enterpriseTabComponent";
import { useEffect, useState } from "react";
import { getCompanyContractList } from "../API/AppRepository";

const HomeContainer = styled.div`
  width: 90vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 6vw;
`;

const TabContainer = styled.div`
  width: 90vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default function EnterpriseContractList() {
  const [receiptList, setReceiptList] = useState<any[]>([]);
  useEffect(() => {
    const fetchCompanyContractList = async () => {
      const list = await getCompanyContractList();
      setReceiptList(list);
    };
    fetchCompanyContractList();
  }, []);
  return (
    <>
      <FlexXY>
        <HomeContainer>
          <TabContainer>
            <EnterpriseTabComponent
              receiptList={receiptList}
            ></EnterpriseTabComponent>
          </TabContainer>
        </HomeContainer>
      </FlexXY>
    </>
  );
}
